module.exports = __webpack_public_path__ + "img/drMedicPro.775a18ce.png";